module.exports = __webpack_public_path__ + "static/media/seo.aa6f8c1a.svg";